<template>
    <v-app>

      <v-app-bar app :class="[
          $route.name == 'EventsCreate' ? 'barra-branca' : 'barra-rosa',
          'feathered-edges', 
          'bottom',
        ]" 
        style="position: sticky; z-index: 9">
        <v-toolbar-title>
          <router-link to="/">
            <v-img
              src="@/assets/mclogoV2.1.svg"
              class="nav-logo"
            ></v-img>
          </router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>

      <template>
        <v-app-bar-nav-icon @click="drawer = !drawer" class=" icon-container">
          <v-icon 
              :class="{ 'rotate-in': drawer, 'rotate-out': !drawer }" 
              style="color: black;" 
              id="menu-icon"
              large
            >
            {{ drawer ? 'mdi-close' : 'mdi-menu' }}
          </v-icon>
        </v-app-bar-nav-icon>
      </template>

          
        <div class="app-bar-actions">
        <template >
          <v-btn text class="redirect_button" @click="terms = true;">
            <span>termos e condições</span>
          </v-btn>
        </template>
        <template >
          <v-btn text class="redirect_button" @click="openPolicy">
            <span>política de privacidade</span>
          </v-btn>
        </template>
        <template>
          <v-btn text class="redirect_button" @click="openPro">
            <span>matchcalendars pro</span>
          </v-btn>
        </template>
        <template >
          <v-btn text class="redirect_button" @click="openContacts">
            <span>contacto</span>
          </v-btn>
        </template>
        <v-tooltip bottom v-if="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="logout" text class="redirect_button">
              <span>sair</span>
            </v-btn>
          </template>
          <span>Sair</span>
        </v-tooltip>
      </div>
      </v-app-bar>

      <!-- Drawer para Mobile -->
      <v-navigation-drawer v-model="drawer"  app class="d-md-none burger_container" :style="{width: '100%', height: '100vh', paddingTop: '4rem' }">
          <v-list>
            <v-list-item @click="openPro">
              <v-list-item-content class="redirect_button">matchcalendars pro</v-list-item-content>
            </v-list-item>

            <v-list-item @click="openContacts">
              <v-list-item-content class="redirect_button">contacto</v-list-item-content>
            </v-list-item>

            <v-list-item @click="logout">
              <v-list-item-content class="redirect_button" @click="terms = true;">termos e condições</v-list-item-content>
            </v-list-item>

            <v-list-item @click="logout">
              <v-list-item-content class="redirect_button" @click="openPolicy">política de privacidade</v-list-item-content>
            </v-list-item>
          </v-list>
      </v-navigation-drawer>
      <v-main style="padding: 0;" class="bg">

        <div>
        <v-row class="align-center">
          <!-- Coluna esquerda -->
          <v-col cols="12" md="4" class="left-column">
           
            <validation-observer v-if="!codeSent" ref="form" v-slot="{ invalid }">
              <v-form @submit.prevent="register" class="mc-form register">
                <h1>criar conta</h1>
                <v-row no-gutters>
                  <v-col cols="12" lg="8">
                    <validation-provider v-slot="{ errors }" vid="Nome" name="Nome" rules="required">
                      <v-text-field
                        class="entrada-dados"
                        v-model="name"
                        label="Nome *"
                        :error-messages="errors"
                        solo
                        flat
                        hide-details="auto"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" lg="8">
                    <validation-provider v-slot="{ errors }" vid="Email" name="Email" rules="required">
                      <v-text-field
                        class="entrada-dados"
                        v-model="email"
                        label="Email *"
                        type="email"
                        solo
                        flat
                        :error-messages="errors"
                        required
                        hide-details="auto"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" lg="8">
                    <validation-provider v-slot="{ errors }" vid="Palavra-passe" name="Palavra-passe" rules="required|password_size|special_char_1|capital_letter|small_letter|one_number">
                      <v-text-field
                        class="entrada-dados"
                        v-model="password"
                        type="password"
                        label="Palavra-passe *"
                        :error-messages="errors"
                        solo
                        flat
                        hide-details="auto"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" lg="8">
                    <validation-provider v-slot="{ errors }" vid="Confirmar palavra-passe" name="Confirmar palavra-passe" rules="required|password:@Palavra-passe">
                      <v-text-field
                        class="entrada-dados"
                        :error-messages="errors"
                        v-model="password_confirmation"
                        type="password"
                        label="Confirmar palavra-passe *"
                        solo
                        flat
                        hide-details="auto"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" lg="8">
                    <v-btn 
                      :disabled="invalid" 
                      depressed 
                      color="black" 
                      class="register-btn mt-5" 
                      style="text-transform: none !important;"
                      type="submit"
                      rounded 
                      block
                      large
                    >
                      Registar
                    </v-btn>
                  </v-col>
                </v-row>                  
              </v-form>
            </validation-observer>

            <v-form v-else @submit.prevent="verifyCode">
              <p class="text-center" style="font-size: 14px;">Introduza o código enviado para {{ email }}</p>
              <v-text-field
                class="entrada-dados"
                v-model="verificationCode"
                label="Código de Verificação"
                solo
                flat
                hide-details
                required
              ></v-text-field>

              <v-btn depressed color="black" class="register-btn mt-4" type="submit" rounded block large>
                Confirmar Código
              </v-btn>
            </v-form>
  
            
            <p class="last-text-costumize">Já tem conta? <router-link to="/login">Entrar</router-link></p>
            <p class="last-text-costumize">Ao registar-se aceita os nossos 
              <button @click="terms = true;" class="link-button">termos e condições </button> e 
              <button @click="openPolicy" class="link-button">política de privacidade</button></p>
            
          </v-col>
  
          <!-- Coluna direita -->
          <v-col cols="12" md="6" class="right-column d-none d-md-flex">
            <v-img
              src="@/assets/papelEventos1.png"
              alt="Imagem de Login"
              max-width="100%"
              height="auto"
              contain
              class="img_size"
            />
          </v-col>
        </v-row>
        </div>
        
      </v-main>

      <Politica @close="policy = false;" v-if="policy" />

      <Termos @privacy-open="policy = true" @close="terms = false;" v-if="terms" />

      <ContactoModal @close="contacto = false;" v-if="contacto" />

      <ProModal @close="pro = false;" v-if="pro" />
    </v-app>
</template>
  
<script>
    import User from "@/api/User.js";
    import Politica from "@/views/PoliticaPrivacidade.vue"
    import Termos from '@/views/TermosCondicoes.vue'
    import ContactoModal from "./ContactoModal.vue"
    import ProModal from "./ProModal.vue"
  
  export default {
    components: {
    Politica,
    Termos,
    ContactoModal,
    ProModal
  },
  mounted(){
      if(localStorage.getItem('email_to_confirm')){
        this.email = localStorage.getItem('email_to_confirm');
        this.codeSent = true;
        this.resendNewCode()
        localStorage.removeItem('email_to_confirm');
      }
  },
    data() {
      return {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        verificationCode: '',
        codeSent: false,
        drawer: false,
        policy: false,
        terms: false,
        contacto: false,
        pro: false,
      };
    },
  methods: {
    openPolicy(){
      this.policy = true;
    },

    openContacts(){
      this.contacto = true;
    },
    resendNewCode(){
      User.resendNewCode({email: this.email});
    },
    openPro(){
      this.pro = true;
    },
    async register() {

      const params = {
        name: this.name,
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation
      };

      try {
        await User.registerRequest(params);
        this.codeSent = true;
      } catch (error) {
        console.error('Erro no registo:', error.response.data);
      }
    },

    async verifyCode() {

      const params = {
        email: this.email,
        code: this.verificationCode,
        name: this.name,
        password: this.password
      };

      try {
        await User.verifyCode(params);
        alert("Registo concluído! Pode agora iniciar sessão.");
        this.$router.push('/login');
      } catch (error) {
        alert("Código inválido.");
      }
    }
    }
  };
</script>
  
<style scoped>
  .link-button {
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    text-decoration: underline;
  }

.last-text-costumize {
  width: 100%;
}
  
  .logo-container {
    text-align: right;
    margin-bottom: 120px;
    margin-top: 1cm;
  }

  /* Botão Registar */
  .register-btn {
    background-color: #111b2d !important;
    color: #E9CFED !important;
    border-radius: 30px !important;
    box-shadow: none !important;
    margin-bottom: 2cm;
    font-size: 14px;
    font-weight: 700;
  }
  
  .text-center {
    text-align: center;
  }
  
  
  .theme--light.v-btn.v-btn--icon[data-v-63ae9146] {
    color: rgba(0, 0, 0, 0) !important; 
  }

  @media (max-width: 768px) {

    .register-btn {
      width: 91% !important; /* Ocupa 100% da largura da coluna */
      min-width: unset !important; /* Remove limites mínimos de largura */
      max-width: unset !important; /* Remove qualquer limitação de largura */
      height: 48px !important; /* Ajusta a altura para igualar os text fields */
      display: flex;
      align-items: center;
      justify-content: center;  
      width: 100% !important;
      text-transform: none !important;  
    }

    .last-text-costumize {
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 16px;

      button {
        text-decoration: underline;
      }
    }
  }
</style>
  